import { TabKeys } from "../../data/tabs";
import { MenuItemProps } from "./menu-item/MenuItem.component";

export interface MenuItem extends MenuItemProps {
  index: number;
}

export const mainMenu: MenuItem[] = [
  {
    index: 1,
    title: "Home",
    icon: false,
    disabled: false,
    collapsible: false,
    tabKey: TabKeys.Home,
  },
  {
    index: 2,
    title: "About",
    icon: false,
    disabled: false,
    collapsible: false,
    tabKey: TabKeys.About,
  },
  {
    index: 3,
    title: "Services",
    icon: false,
    disabled: false,
    collapsible: false,
    tabKey: TabKeys.Services,
  },
  {
    index: 4,
    title: "Contact",
    icon: false,
    disabled: false,
    collapsible: false,
    tabKey: TabKeys.Contact,
  },
];
